/**
 * Global screen reader announcer.
 * Creates a persistent aria-live="polite" region directly on document.body
 * so it is never affected by popup aria-hidden or inert attributes.
 *
 * The announcer clears the previous message before setting the new one
 * (with a brief delay) to ensure repeated identical messages are re-announced.
 */
var debounceTimer = null;
var announcerEl = null;
function getAnnouncer() {
    if (announcerEl && document.body.contains(announcerEl))
        return announcerEl;
    // Create a new announcer element directly on document.body
    announcerEl = document.createElement('div');
    announcerEl.id = 'sr-announcer';
    announcerEl.setAttribute('aria-live', 'polite');
    announcerEl.setAttribute('aria-atomic', 'true');
    announcerEl.setAttribute('role', 'status');
    Object.assign(announcerEl.style, {
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: '0',
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: '0',
    });
    document.body.appendChild(announcerEl);
    return announcerEl;
}
export var announce = function (message) {
    var el = getAnnouncer();
    // Clear first to ensure re-announcement of same message
    el.textContent = '';
    if (debounceTimer)
        clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
        el.textContent = message;
    }, 100);
};
/**
 * High-priority announcer — interrupts current screen reader speech.
 * Uses a separate aria-live="assertive" element (created once, cached).
 * Use for delete, duplicate, and other critical state change announcements
 * that must be heard even when focus is moving.
 */
var assertiveEl = null;
var assertiveTimer = null;
function getAssertiveAnnouncer() {
    if (assertiveEl && document.body.contains(assertiveEl))
        return assertiveEl;
    assertiveEl = document.createElement('div');
    assertiveEl.id = 'sr-announcer-assertive';
    assertiveEl.setAttribute('aria-live', 'assertive');
    assertiveEl.setAttribute('aria-atomic', 'true');
    assertiveEl.setAttribute('role', 'alert');
    Object.assign(assertiveEl.style, {
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: '0',
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: '0',
    });
    document.body.appendChild(assertiveEl);
    return assertiveEl;
}
export var announceAssertive = function (message) {
    var el = getAssertiveAnnouncer();
    el.textContent = '';
    if (assertiveTimer)
        clearTimeout(assertiveTimer);
    assertiveTimer = setTimeout(function () {
        el.textContent = message;
    }, 50);
};
